var React = require('react');

function ButtonShape01 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st6","d":"M153.16,15.72C112.71,2.58,63.64-0.97,22.92,0.32C4.64,0.89-0.43,16.71,1.84,34.54s5.7,28.73,22.22,36.93\n\ts76.22,8.38,124.92,3.27c11.78-1.24,30.17-4.47,27.27-29.42C174.8,32.88,172.45,21.99,153.16,15.72z"}));
}

ButtonShape01.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape01;

ButtonShape01.default = ButtonShape01;
